import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';
import { LabeledInput } from '@work4all/components/lib/input/labeled-input';

import { PriceGroupPickerField } from '../../../../../../../../../../components/entity-picker/PriceGroupPickerField';
import { RythmPickerField } from '../../../../../../../../../../components/entity-picker/RythmPickerField';
import { ControllerPlus } from '../../../../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { DateTimeInputPicker } from '../../../../../../../../locked-inputs';
import { TabPanelSectionProps } from '../../../../../../../types';
import { ServiceContractsFormValue } from '../../../../../types';

export const SubscriptionContract: React.FC<TabPanelSectionProps> = () => {
  const { t } = useTranslation();

  const { control, watch } = useFormContextPlus<ServiceContractsFormValue>();

  const includedMinutesPerMonth = watch('includedMinutesPerMonth');
  const priceTotal = watch('priceTotal');

  return (
    <Collapse title={t('COMMON.CONTRACTDATA')} defaultOpen={true}>
      <Grid container spacing="1rem">
        <Grid item xs={12} md={4} lg={2}>
          <Controller
            name="serviceContractStartDate"
            control={control}
            render={({ field }) => (
              <DateTimeInputPicker
                {...field}
                dateLabel={t('SERVICECONTRACT.CONTRACT_START')}
                data-testid="start-service-contract"
                withTime={false}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <Controller
            name="serviceContractEndDate"
            control={control}
            render={({ field }) => (
              <DateTimeInputPicker
                {...field}
                dateLabel={t('SERVICECONTRACT.CONTRACT_END')}
                data-testid="end-service-contract"
                withTime={false}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <Controller
            name="terminationDate"
            control={control}
            render={({ field }) => (
              <DateTimeInputPicker
                {...field}
                dateLabel={t('SERVICECONTRACT.TERMINATION_DATE')}
                data-testid="termination-date"
                withTime={false}
              />
            )}
          />
        </Grid>
        <Grid item xs={6} sm={2}>
          <ControllerPlus
            control={control}
            name="rythm"
            render={({ field }) => {
              return <RythmPickerField {...field} />;
            }}
          />
        </Grid>

        <Grid item xs={6} sm={2}>
          <ControllerPlus
            name="nextInvoiceDate"
            control={control}
            render={({ field }) => (
              <DateTimeInputPicker
                {...field}
                dateLabel={t('FIELDS.nextInvoiceDate')}
                data-testid="service-contract-next-invoice-date"
                withTime={false}
              />
            )}
          />
        </Grid>

        <Grid item xs={6} sm={2}>
          <ControllerPlus
            name="priceGroup"
            control={control}
            render={({ field, fieldState }) => {
              return (
                <PriceGroupPickerField
                  {...field}
                  error={fieldState?.error?.message}
                />
              );
            }}
          />
        </Grid>

        <Grid item xs={6} sm={2}>
          <LabeledInput
            value={includedMinutesPerMonth}
            label={t('SERVICECONTRACT.INCLUDED_MIN_MONTH')}
            type="number"
            disabled
          />
        </Grid>

        <Grid item xs={6} sm={2}>
          <LabeledInput
            value={priceTotal}
            label={t('COMMON.TOTAL')}
            type="number"
            disabled
          />
        </Grid>
      </Grid>
    </Collapse>
  );
};
